import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuthToken } from "../../../src/utility/utils";
import { API } from "../../api/api";
import config from "../../config";
import { store } from "../../store/store";
import { showLoader } from "../reducer/commonReducer";
export interface IAuthorization {
  authData: any;
  status: "idle" | "loading" | "failed";
}

const initialState: IAuthorization = {
  authData: getAuthToken(),
  status: "idle",
};

export const whoamiAPI = createAsyncThunk("whoamiAPI", async (request: any) => {
  let headers: any = {
    Subscription: config.Subscription,
    "Client-Id": config.ClientId,
    "Client-Secret": config.ClientSecret,
  };
  const response = await API.Get(`${config.BASE_URL}/whoami`,{headers} );
  localStorage.setItem("WOH_AM_I_DATA",JSON.stringify(response))
  return response;
});
export const OnLoginAsync = createAsyncThunk("auth/signIn", async (request: any) => {

  store.dispatch(showLoader({ isLoader: true }));
  let headers: any = {
    Subscription: config.Subscription,
    "Client-Id": config.ClientId,
    "Client-Secret": config.ClientSecret,
  };
  
  const result = await API.Post(
    `${config.BASE_URL}/Identity/ThirdPartyLogin`,
    {
      ...request,
    },
    {headers}
  );
  if (result) {
    store.dispatch(showLoader({ isLoader: false }));
  }
  return result
});
  
export const authSlice: any = createSlice({
  name: "authReducer",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},

  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder: any) => {
    builder
      .addCase(OnLoginAsync.pending, (state: any) => {
        state.status = "loading";
      })
      .addCase(OnLoginAsync.fulfilled, (state: any, action: any) => {
        state.status = "idle";
        state.authData = [];
        state.authData = action.payload;
      })
      .addCase(OnLoginAsync.rejected, (state: any) => {
        state.status = "failed";
        state.authData = [];
      })  

  },
});

export const { } = authSlice.actions;

export default authSlice.reducer;
